import { Link } from "react-router-dom";
import { useState } from "react";
import ProductAddOns from "../products/product-addons";
import { ICartItem } from "../../stores/cart";
import { useStores } from "../../stores/root-store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

interface ICustomiseAddOns {
  cartItem: ICartItem;
}

const CustomiseAddOns = ({ cartItem }: ICustomiseAddOns) => {
  const { cartStore } = useStores();
  const { addItemToCart } = cartStore;
  const [showAddOnsModal, setShowAddOnsModal] = useState(false);

  const handleAddToCart = (cartItem: any) => {
    addItemToCart(cartItem, cartItem.Quantity, true);
    setShowAddOnsModal(false);
  };

  return (
    <>
      <Link
        to="#"
        className="text-secondary text-decoration-none"
        onClick={() => setShowAddOnsModal(true)}
      >
        <FontAwesomeIcon icon={faEdit} />
        Customise
      </Link>
      {showAddOnsModal && (
        <ProductAddOns
          cartItem={cartItem}
          isModalOpen={showAddOnsModal}
          onModalClose={() => setShowAddOnsModal(false)}
          addProductToCart={handleAddToCart}
          isEditRequest={true}
          itemQty={cartItem.Quantity}
          setItemQty={() => {}}
        />
      )}
    </>
  );
};

export default CustomiseAddOns;
